import { LitElement, html, animate, scroll, utils } from '@hh/global.js'

const { isDesktop } = utils
class HHHeaderAnimation extends LitElement {
  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()

    this.handleScrollAnimation()
  }

  handleScrollAnimation() {
    const el = this.querySelector('.js-banner-logo')
    const overlayTarget = this.querySelector('.js-header-ma-overlay')

    const scrollValue = isDesktop() ? '65%' : '40%'

    scroll(
      animate(el, {
        maxHeight: ['500px', '40px'],
      }),
      {
        target: overlayTarget,
        offset: ['start', scrollValue],
      }
    )
  }

  render() {
    return html`<slot></slot>`
  }

  createRenderRoot() {
    return this
  }
}

customElements.define('hh-header-animation', HHHeaderAnimation)
